import { APIFactory, factory } from './../api';

const ModuleName = 'RessieApp';

export class GiftAPI extends APIFactory {

  /* @ngInject */
  constructor(...args) {
    super(...args);
    this.actions = {
      'view': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/gift/:id`
      },
      'list': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/giftsby/:type/:page`
      },
      'delete': {
        'method': 'DELETE',
        'url': `${this.api.getDomain()}/gift/:id`
      },
      'voucher': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/gift/:id/send`
      },
      'receipt': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/gift/:id/receipt`
      },
      'search': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/gift/find`
      },
      'token': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/gift/token`,
        interceptor: {
          response: function (response) {
            return { code: response.data }
          }
        }
      },
      'promo': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/gift/promo`
      },
      'donation': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/gift/donation`
      },
      'save': {
        'method': 'POST',
        'url': `${this.api.getDomain()}/gifts`,
      },
      'update': {
        'method': 'PUT',
        'url': `${this.api.getDomain()}/gift/:id`,
        'params': { id: '@_id' },
      }
    };
  }

  get url() {
    return `${this.api.getDomain()}/gift/:id`;
  }

  setAction(name, obj) {
    this.actions[name] = obj;
  }

};

export const API = (MODULE) => {
  return factory(MODULE, 'GiftAPI', GiftAPI);
}

export default () => {
  return API(ModuleName);
};




// WEBPACK FOOTER //
// ./client/assets/scripts/modules/gifts/api.js